import Layout from "@/components/layout/Layout";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import Categories from "./components/Categories";
import NewArrivals from "./components/NewArrivals";
import Ranking from "./components/Ranking";
import VipBanner from "./components/VipBanner";
import Testimonials from "./components/Testimonials";
import FaqPreview from "./components/FaqPreview";

function Home() {
  return (
    <Layout
      title="土豪漫画网-尊享漫画|钻石漫画|贵族漫画|专属特权阅读"
      description="土豪漫画网土豪专区提供尊享漫画、钻石漫画、贵族漫画、豪华漫画等专属内容，专属特权阅读，豪华画质，尊贵体验，满足土豪专属漫画需求。"
    >
      <Hero />
      <Featured />
      <Categories />
      <Ranking />
      <NewArrivals />
      <VipBanner />
      <Testimonials />
      <FaqPreview />
    </Layout>
  );
}

export default Home;